export const menuOrder = [
  { code: 'FASTFOODSTARTER', order: 1 },
  { code: 'STARTER', order: 2 },
  { code: 'DISH', order: 3 },
  { code: 'SIDE', order: 4 },
  { code: 'DAIRY', order: 5 },
  { code: 'DESSERT', order: 6 },
  { code: 'WATER', order: 7 },
  { code: 'JUICE', order: 8 },
  { code: 'SODA', order: 9 },
  { code: 'SHORTDRINK', order: 10 },
  { code: 'BEER', order: 11 },
  { code: 'WINE', order: 12 },
  { code: 'DIGESTIF', order: 13 },
  { code: 'HOTDRINKS', order: 14 },
  { code: 'GROCERY', order: 15 },
  { code: 'ACCOMPANIMENT', order: 16 },
  { code: 'PREPARATION', order: 17 },
  { code: 'SNACK', order: 18 },
  { code: 'SAUCE', order: 19 },
];

export enum MenuOrderEnum {
  FASTFOODSTARTER = 'FASTFOODSTARTER',
  STARTER = 'STARTER',
  SIDE = 'SIDE',
  DISH = 'DISH',
  DAIRY = 'DAIRY',
  DESSERT = 'DESSERT',
  WATER = 'WATER',
  JUICE = 'JUICE',
  SODA = 'SODA',
  SHORTDRINK = 'SHORTDRINK',
  BEER = 'BEER',
  WINE = 'WINE',
  DIGESTIF = 'DIGESTIF',
  HOTDRINKS = 'HOTDRINKS',
  GROCERY = 'GROCERY',
  ACCOMPANIMENT = 'ACCOMPANIMENT',
  PREPARATION = 'PREPARATION',
  SNACK = 'SNACK',
  SAUCE = 'SAUCE',
}
